import { useContext, useMemo } from 'react'

import PortalConfigContext, {
  PermissionsAction
} from '../../context/PortalConfigContext'
import { isConfigMode } from '../../utils/StyleUtils'

const FILE_RESOURCE = 'file'

export const useDocumentPermissions = () => {
  const { actions: portalConfigActions } = useContext(PortalConfigContext)

  const isViewDocumentPermitted: boolean = useMemo(() => {
    if (isConfigMode()) {
      return true
    }

    return portalConfigActions.isPermitted(
      PermissionsAction.ENTITY_VIEW,
      FILE_RESOURCE
    )
  }, [portalConfigActions])

  const isDeleteDocumentDetailsPermitted: boolean = useMemo(() => {
    if (isConfigMode()) {
      return true
    }

    return portalConfigActions.isPermitted(
      PermissionsAction.ENTITY_DELETE,
      FILE_RESOURCE
    )
  }, [portalConfigActions])

  const isUploadDocumentDetailsPermitted: boolean = useMemo(() => {
    if (isConfigMode()) {
      return true
    }

    return portalConfigActions.isPermitted(
      PermissionsAction.ENTITY_CREATE,
      FILE_RESOURCE
    )
  }, [portalConfigActions])

  return {
    isViewDocumentPermitted,
    isDeleteDocumentDetailsPermitted,
    isUploadDocumentDetailsPermitted
  }
}
